import { ToastContainer } from "react-toastify";
import MyFiles from "./MyFiles";

interface FileManagerModalProps {
    botId: string;
    name: string;
    open: boolean;
    onClose: () => void;
}

const FileManagerModal = ({
    name,
    botId,
    open,
    onClose,
}: FileManagerModalProps) => {
    if (!open) return null;

    return (
        <>
            <ToastContainer
                position="top-center"
                className="!z-[9999]"
                style={{ position: 'fixed', top: '20px' }}
            />
            
            <div className="fixed inset-0 z-50 overflow-y-auto">
                <div
                    className="fixed inset-0 bg-black bg-opacity-50 transition-opacity"
                    onClick={onClose}
                />
                <div className="flex items-center justify-center min-h-screen p-4">
                    <div className="relative bg-white rounded-lg shadow-xl w-full max-w-6xl mx-auto z-50">
                        <MyFiles onClose={onClose} bucketName={name} botId={botId} />
                    </div>
                </div>
            </div>
        </>
    );
};
export default FileManagerModal;
